export default __webpack_public_path__ + "static/media/14 KYCDetails – 2.a5b09d4f.png";